import { Check, Rocket, Zap, Sparkles } from 'lucide-react';
import { GradientButton } from '@/components/common';
import { useNavigate } from 'react-router-dom';

export default function PricingPlans() {
	const plans = [
		{
			tag: "For Getting Started",
			title: "Silver",
			icon: Rocket,
			description: "Essential Communication for Small Businesses",
			monthlyPrice: "$25",
			yearlyPrice: "$21",
			features: [
				"Remote and Phone Support",
				"Workstation Monitoring",
				"Patch Management",
				"Cyber Security (EDR)",
				"Monthly Report"
			]
		},
		{
			tag: "For boosting productivity",
			title: "Gold",
			icon: Zap,
			description: "Enhanced Features for Growing Teams",
			monthlyPrice: "$47",
			yearlyPrice: "$46",
			features: [
				"Remote and Phone Support",
				"Workstation Monitoring",
				"Patch Management",
				"Cyber Security (EDR)",
				"Monthly Report",
				"Web Protection",
				"Risk Intelligence"
			],
			recommended: true
		},
		{
			tag: "For collaboration & flexibility",
			title: "Diamond",
			icon: Sparkles,
			description: "Full-Featured Communication Solution for Large Businesses",
			monthlyPrice: "$63",
			yearlyPrice: "$61",
			features: [
				"Remote and Phone Support",
				"Workstation Monitoring",
				"Patch Management",
				"Cyber Security (EDR)",
				"Monthly Report",
				"Web Protection",
				"Risk Intelligence",
				"Backup and Restore",
				"Unlimited Email Support"
			]
		}
	];
	
	const navigate = useNavigate();

	const handleContactClick = () => {
		navigate('/request-for-services');
	};

	return (
		<div className="container pt-24 pb-12">
			{/* Header */}
			<h3 className="text-3xl md:text-4xl text-center font-bold text-white md:leading-tight mb-14">
				Our Packages
			</h3>

			{/* Pricing Cards */}
			<div className="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-7xl mx-auto mb-12 items-stretch">
				{plans.map((plan, index) => (
					<div key={index} className="relative h-full">
						{/* Recommended Badge */}
						{plan.recommended && (
							<div className="absolute -top-4 left-0 right-0 z-10 flex justify-center">
								<div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white px-6 py-2 rounded-full text-xs font-bold uppercase tracking-wide shadow-lg">
									Recommended
								</div>
							</div>
						)}

						<div
							className={`h-full flex flex-col bg-gradient-to-br from-gray-900/50 to-gray-800/50 backdrop-blur-xl rounded-2xl px-7 py-8 border ${
								plan.recommended
									? 'border-purple-500/50 shadow-2xl shadow-purple-500/20'
									: 'border-purple-500/20'
							} hover:border-purple-500/50 transition-all duration-300`}
						>
							{/* Icon */}
							<div className="w-16 h-16 rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mb-6">
								<plan.icon className="w-8 h-8 text-white" strokeWidth={2} />
							</div>

							{/* Title */}
							<h2 className="text-white text-2xl font-bold mb-4 leading-snug">
								{plan.title}
							</h2>

							{/* Description */}
							<p className="text-gray-300 text-sm mb-6">
								{plan.description}
							</p>

							{/* Divider */}
							<div className="h-px bg-gradient-to-r from-transparent via-purple-500/30 to-transparent mb-6" />

							{/* Features */}
							<div className="flex-grow">
								<h3 className="text-white font-bold mb-4">Features:</h3>
								<ul className="space-y-4">
									{plan.features.map((feature, idx) => (
										<li key={idx} className="flex items-start gap-3">
											<div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mt-0.5">
												<Check className="w-3 h-3 text-white" strokeWidth={3} />
											</div>
											<span className="text-gray-300 text-sm leading-relaxed">
												{feature}
											</span>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				))}
			</div>

			{/* Single CTA Button */}
			<div className="flex justify-center">
				<GradientButton 
					className="px-12 py-4 text-white font-semibold text-lg" 
					onClick={handleContactClick}
				>
					Get Started
				</GradientButton>
			</div>
		</div>
	);
}